"use client";

import { Loader2 } from "lucide-react";
import { CourseCard } from "../../../../components/CourseCard";
import { useAPI } from "../../../../context/APIContext";

export default function CoursesList({ onSelectCourse }) {
  const { coursesItems } = useAPI();
  const { loadingCourses, courses } = coursesItems;

  if (loadingCourses) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!courses.length) {
    return (
      <div className="text-center p-12 border rounded-lg">
        <h3 className="text-lg font-medium">No courses found</h3>
        <p className="text-muted-foreground mt-2">
          Check back later for new courses
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {courses.map((course) => (
        <CourseCard
          key={course.id}
          courseType="available"
          item={course}
          btnTitle="Enroll Now"
          onClick={() => onSelectCourse(course)}
        />
      ))}
    </div>
  );
}
